// @flow
// This util is being used because this is how the TDS NRL Fantasy project does it.
// The JSON stringify and parse was important for 'user_requested_route_before_auth'
// key that is used across both apps
const storage = window.localStorage;

export default class Storage {
	constructor(): void {
		throw new Error('this class can\'t be an instance');
	}

	static get(key: string): string | null {
		return storage.getItem(key) ? JSON.parse(storage.getItem(key)) : null;
	}

	static set(key: string, value: string): void {
		storage.setItem(key, JSON.stringify(value));
	}

	static remove(key: string): void {
		storage.removeItem(key);
	}

	static clear(): void {
		storage.clear();
	}
}


// WEBPACK FOOTER //
// ./src/utils/storage/LocalStorage.js